(function () {
'use strict';

(function(rum) {
    // идентификатор для очистки stack от RumTraceablePromise
    var TRACEABLE_PROMISE_ID = '__RumTraceablePromise';

    rum._parseTraceablePromiseStack = function(promise) {
        if (!promise || !promise.__stack) {
            return;
        }

        // удаляем из stack строки с упоминанием RumTraceablePromise - они бесполезны
        var lines = promise.__stack.split('\n');
        var result = [];
        for (var i = 0; i < lines.length; i++) {
            if (lines[i].indexOf(TRACEABLE_PROMISE_ID) === -1) {
                result.push(lines[i].trim());
            }
        }
        return result.join('\n');
    };

    rum._traceUnhandledRejection = function() {
        if (!('Promise' in window) || window.Promise.name === TRACEABLE_PROMISE_ID) {
            return;
        }

        // переопределяем глобальный Promise на имплементацию, 
        // которая сохраняет stack вызова
        // и позволяет прочитать его в случае unhandledrejection
        var OriginalPromise = window.Promise;
        function RumTraceablePromise(executor) {
            var resolve, reject;
            var _this = new OriginalPromise(function (_resolve, _reject) {
                resolve = _resolve;
                reject = _reject;
            });
            _this.__stack = (new Error(TRACEABLE_PROMISE_ID)).stack;
            try {
                executor(resolve, reject);
            } catch (err) {
                reject(err);
            }
            return _this;
        }
        try {
            RumTraceablePromise.prototype = OriginalPromise.prototype;
            RumTraceablePromise.prototype.constructor = RumTraceablePromise;
            Object.setPrototypeOf(RumTraceablePromise, OriginalPromise);
            Object.defineProperty(RumTraceablePromise, 'name', { value: TRACEABLE_PROMISE_ID });
            window.Promise = RumTraceablePromise;
        } catch (e) {
            //
        }
    };
})(Ya.Rum);

}());
